import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPartyConfettiFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2380_38901)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M22.5657 24.8667C24.018 23.4144 22.8407 19.8826 19.9362 16.978C17.0317 14.0735 13.4998 12.8962 12.0475 14.3485C10.5953 15.8007 11.7726 19.3326 14.6771 22.2371C17.5816 25.1417 21.1135 26.319 22.5657 24.8667Z",
				fill: "#B3CEF1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4547 15.6846L2.22937 31.8643C2.04686 32.2591 1.98987 32.7003 2.0661 33.1285C2.14232 33.5567 2.34808 33.9511 2.6556 34.2587C2.96313 34.5662 3.3576 34.772 3.78577 34.8482C4.21395 34.9244 4.65519 34.8674 5.04995 34.6849L21.2297 25.4667",
				fill: "#B3CEF1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.5941 22.9238C23.0463 21.4716 21.869 17.9397 18.9645 15.0352C16.06 12.1306 12.5281 10.9533 11.0758 12.4056C9.62358 13.8579 10.8009 17.3897 13.7054 20.2943C16.6099 23.1988 20.1418 24.3761 21.5941 22.9238Z",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4835 13.7417L1.25818 29.9215C1.07567 30.3162 1.01868 30.7575 1.0949 31.1856C1.17113 31.6138 1.37689 32.0083 1.68441 32.3158C1.99193 32.6233 2.38641 32.8291 2.81458 32.9053C3.24275 32.9815 3.684 32.9245 4.07876 32.742L20.2585 23.5238",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.3452 10.9087C22.3947 10.958 22.4339 11.0167 22.4607 11.0812C22.4875 11.1457 22.5013 11.2149 22.5013 11.2848C22.5013 11.3547 22.4875 11.4239 22.4607 11.4884C22.4339 11.553 22.3947 11.6116 22.3452 11.6609",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.5942 10.9078C21.6938 10.8083 21.8289 10.7524 21.9697 10.7524C22.1104 10.7524 22.2455 10.8083 22.3451 10.9078",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.5944 11.6551C21.4951 11.555 21.4395 11.4199 21.4395 11.279C21.4395 11.1381 21.4951 11.0029 21.5944 10.9028",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.3451 11.6543C22.2455 11.7538 22.1104 11.8097 21.9697 11.8097C21.8289 11.8097 21.6938 11.7538 21.5942 11.6543",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.356 4.89307C28.4054 4.94229 28.4446 5.0008 28.4714 5.06522C28.4981 5.12965 28.5119 5.19872 28.5119 5.26848C28.5119 5.33824 28.4981 5.40732 28.4714 5.47174C28.4446 5.53617 28.4054 5.59467 28.356 5.6439",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.6055 4.89277C27.6547 4.84334 27.7132 4.80412 27.7776 4.77736C27.842 4.75059 27.9111 4.73682 27.9809 4.73682C28.0506 4.73682 28.1197 4.75059 28.1841 4.77736C28.2486 4.80412 28.3071 4.84334 28.3563 4.89277",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.6052 5.6439C27.5557 5.59467 27.5165 5.53617 27.4898 5.47174C27.463 5.40732 27.4492 5.33824 27.4492 5.26848C27.4492 5.19872 27.463 5.12965 27.4898 5.06522C27.5165 5.0008 27.5557 4.94229 27.6052 4.89307",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.3563 5.64453C28.2567 5.74402 28.1217 5.7999 27.9809 5.7999C27.8401 5.7999 27.7051 5.74402 27.6055 5.64453",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.356 19.918C28.4054 19.9673 28.4447 20.0259 28.4715 20.0905C28.4982 20.155 28.512 20.2242 28.512 20.2941C28.512 20.364 28.4982 20.4332 28.4715 20.4977C28.4447 20.5622 28.4054 20.6209 28.356 20.6702",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.6055 19.9181C27.7051 19.8186 27.8401 19.7627 27.9809 19.7627C28.1217 19.7627 28.2567 19.8186 28.3563 19.9181",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.6053 20.6702C27.5558 20.6209 27.5166 20.5622 27.4898 20.4977C27.463 20.4332 27.4492 20.364 27.4492 20.2941C27.4492 20.2242 27.463 20.155 27.4898 20.0905C27.5166 20.0259 27.5558 19.9673 27.6053 19.918",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.3563 20.6704C28.2567 20.7699 28.1217 20.8258 27.9809 20.8258C27.8401 20.8258 27.7051 20.7699 27.6055 20.6704",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.8276 6.39453C11.9269 6.49456 11.9825 6.62976 11.9825 6.77066C11.9825 6.91156 11.9269 7.04675 11.8276 7.14678",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0771 6.39462C11.1768 6.29514 11.3118 6.23926 11.4526 6.23926C11.5933 6.23926 11.7284 6.29514 11.828 6.39462",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.077 7.14678C11.0275 7.09743 10.9882 7.03881 10.9615 6.97427C10.9347 6.90973 10.9209 6.84053 10.9209 6.77066C10.9209 6.70078 10.9347 6.63159 10.9615 6.56705C10.9882 6.5025 11.0275 6.44388 11.077 6.39453",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.828 7.14697C11.7284 7.24646 11.5933 7.30234 11.4526 7.30234C11.3118 7.30234 11.1768 7.24646 11.0771 7.14697",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.2142 1.0625C18.5132 3.73988 18.2571 6.45017 17.4619 9.02417",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.473 3.01465L22.7222 6.77023",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.9373 15.7862C30.2599 15.4871 27.5496 15.7432 24.9756 16.5384",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.9851 10.5269L27.2295 11.2777",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2380_38901",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 34,
			height: 34,
			fill: "white"
		})
	}) })]
});
export default SvgPartyConfettiFilled;
